var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tiptap-btn",class:{ 'is-active': _vm.editor.isActive('bulletList') },attrs:{"type":"button","title":_vm.$t('Bulleted list'),"disabled":_vm.disabled},on:{"click":function($event){_vm.editor.chain().focus().toggleBulletList().run()}}},[_c('FormatListBulletedIcon',{attrs:{"size":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }